export enum MapOrderMarker {
  SourceId = 'order-marker',
  ClusterId = 'order-marker-cluster',
  ClusterCountId = 'order-marker-cluster-count',
  PointId = 'order-marker-point',
  LabelId = 'order-marker-label',
  ClusterPolygonSourceId = 'order-marker-cluster-polygon-source',
  ClusterPolygonLayerId = 'order-marker-cluster-polygon-layer',
  ClusterPolygonOutlineId = 'order-marker-cluster-polygon-outline',
}
